<div *ngIf="record" class="user-content-item">
  <div class="item__left">
    <div class="item__left__img" [class.stacked]="shouldStack">
      <img
        class="cover-img"
        [src]="record.coverImageUrl"
        appDefault="assets/cover.jpg"
        [alt]="
          record?.title
            ? ('general.coverAlt' | translate) + ' ' + record.title
            : ('general.loadingCover' | translate)
        " />
      <img
        src="assets/cover_transparent.png"
        aria-hidden="true"
        [alt]="record?.title ? record.title : ('general.loadingCover' | translate)" />
      <div class="img__type" *ngIf="record?.icon.icon" aria-hidden="true">
        <span [className]="record.icon.className">{{ record.icon.icon }}</span>
        <p>{{ record.icon.key | translate }}</p>
      </div>
    </div>
  </div>

  <div class="item__right">
    <div class="item__right__info">
      <p tabindex="0" [routerLink]="['/info', slug]" class="item__right__title two-line-title">{{ checkout.title }}</p>
      <p class="item__right__author" tabindex="0">{{ checkout.author }}</p>
    </div>
    <div class="item__right__content">
      <div class="item__right__rating">
        <div class="rating-wrapper" *ngIf="record">
          <app-rating class="interactions__rating" [record]="record"></app-rating>
          <app-favorite-button [record]="record"></app-favorite-button>
        </div>
      </div>
      <div class="item__right__details">
        <div class="details__left" tabindex="0">
          <p>{{ 'checkoutHistory.checkedOut' | translate }}</p>
          <span>{{ checkout.startTime | date }}</span>
        </div>
        <div class="details__right" tabindex="0">
          <p>{{ 'checkoutHistory.returned' | translate }}</p>
          <span>{{ checkout.endTime | date }}</span>
        </div>
      </div>
      <app-remove-button [checkout]="checkout" (removed)="onRemoved($event)"></app-remove-button>
    </div>
  </div>
</div>
